'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { useState, useRef, useEffect } from 'react';
import Slider from '../SlideShow/index.js';
import Toast from '../Toast/index.js';
import ReportJobDialog, { openReportDialog } from './ReportJobDialog.js';
import ReportJobSuccessDialog, { openReportSuccessDialog } from './ReportSuccessDialog.js';
import { getSliderItems } from './helper.js';
import { ReportJobModalContext, useReportJob } from './hooks.js';
import { Wrapper, Container, Title, SliderContainer, SliderItemContainer, SliderItemTitle, SliderItemDescription, Link, NextImageWraper, Image } from './styles.css.js';
import translations from './translation.js';
import { LOGIN_POPUP } from '../LoginModal/constants.js';
import Button from '../Button/index.js';
import 'react-dom';
import '../hooks/useMakeSearchable/types.js';
import '../Utils/constants.js';
import '../services/resumes/types.js';
import useDelay from '../hooks/useDelay.js';
import useElementOnScreen from '../Utils/hooks/UseElementOnScreen/index.js';

var SliderItem = function (_a) {
    var sliderItem = _a.sliderItem, buildId = _a.buildId, nextImage = _a.nextImage;
    var link = sliderItem.link, image = sliderItem.image, titleVi = sliderItem.titleVi, descriptionVi = sliderItem.descriptionVi, descriptionEn = sliderItem.descriptionEn, titleEn = sliderItem.titleEn;
    var _b = useReportJob(), data = _b.data, language = _b.language, t = _b.t;
    var _c = data || {}, imagesService = _c.imagesService, faqService = _c.faqService;
    var sliderItemContainerRef = useRef(null);
    var isRenderedRef = useRef(false);
    var isElementOnScreen = useElementOnScreen({
        target: sliderItemContainerRef
    })[0];
    var renderImage = function () {
        var src = "".concat(imagesService, "/images/").concat(image, "?version=").concat(buildId !== null && buildId !== void 0 ? buildId : 0);
        var alt = 'report-job';
        if (!isElementOnScreen && !isRenderedRef.current) {
            return React__default.createElement(NextImageWraper, null);
        }
        isRenderedRef.current = true;
        if (!nextImage) {
            return React__default.createElement(Image, { src: src, alt: alt, loading: 'lazy' });
        }
        return React__default.createElement(NextImageWraper, null, nextImage(src, alt));
    };
    return (React__default.createElement(SliderItemContainer, { ref: sliderItemContainerRef },
        renderImage(),
        React__default.createElement(SliderItemTitle, null, language === 'vi' ? titleVi : titleEn),
        React__default.createElement(SliderItemDescription, null, language === 'vi' ? descriptionVi : descriptionEn),
        React__default.createElement(Link, { href: "".concat(faqService, "/").concat(link) }, t('View detail'))));
};
var ReportJobModal = function (props) {
    var _a = useState(false), isReportSuccess = _a[0], setIsReportSuccess = _a[1];
    var buttonRef = useRef(null);
    var _b = props.data, data = _b === void 0 ? {
        job: {
            jobId: 0,
            companyLogo: '',
            companyName: '',
            jobName: '',
            companyId: 0,
            companyCCPUrl: '',
            isCCP: false,
            isAnonymous: 0
        },
        apiTokenAccess: 'NTFmNWExMDIxMGE4NTFkYTBhZDNjMjZkNzAzZmNkYjg0NmJhMzY3MzY4NzE3ZGE5NDZmNDJmZDY3NjlmYzBmMg',
        isAuthenticated: 0,
        apiGetway: 'https://staging-ms.vietnamworks.com/api-gateway/v1.0',
        isReportJob: false,
        imagesService: 'https://staging-images.vietnamworks.com/images',
        faqService: '',
        redirectPage: '',
        wnwBaseURL: ''
    } : _b, _c = props.language, language = _c === void 0 ? 'vi' : _c, _d = props.useGlobalToast, useGlobalToast = _d === void 0 ? false : _d, _e = props.locationClassName, locationClassName = _e === void 0 ? '' : _e, styles = props.styles, _f = props.buildId, buildId = _f === void 0 ? 0 : _f, nextImage = props.nextImage, _g = props.delayTime, delayTime = _g === void 0 ? 1000 : _g;
    var delay = useDelay(delayTime);
    var _h = data || {}, isAuthenticated = _h.isAuthenticated, isReportJob = _h.isReportJob;
    var t = function (text) {
        if (language === 'vi') {
            return translations[text];
        }
        return text;
    };
    var handleReport = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isSuccess;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, openReportDialog(locationClassName)];
                case 1:
                    isSuccess = _a.sent();
                    if (!isSuccess) return [3 /*break*/, 3];
                    return [4 /*yield*/, openReportSuccessDialog(locationClassName)];
                case 2:
                    _a.sent();
                    setIsReportSuccess(true);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleClickReport = function () { return __awaiter(void 0, void 0, void 0, function () {
        var loginEvent;
        return __generator(this, function (_a) {
            if (!isAuthenticated) {
                loginEvent = new CustomEvent(LOGIN_POPUP, {
                    detail: {
                        langCode: language,
                        isNeedReload: true
                    }
                });
                window.dispatchEvent(loginEvent);
                return [2 /*return*/];
            }
            handleReport();
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        var timeout = setTimeout(function () {
            var queryParams = new URLSearchParams(window.location.search.substring(1));
            var reportParam = queryParams.get('report');
            if (reportParam === 'true') {
                handleClickReport();
            }
        }, 0);
        return function () {
            clearTimeout(timeout);
        };
    }, []);
    var isReportedJob = isReportJob || isReportSuccess;
    var sliderItems = getSliderItems();
    return (React__default.createElement(ReportJobModalContext.Provider, { value: {
            data: data,
            language: language,
            useGlobalToast: useGlobalToast,
            locationClassName: locationClassName,
            t: t
        } },
        React__default.createElement(React__default.Fragment, null,
            !useGlobalToast && React__default.createElement(Toast, null),
            React__default.createElement(ReportJobDialog, null),
            React__default.createElement(ReportJobSuccessDialog, null),
            React__default.createElement(Wrapper, { style: styles },
                React__default.createElement(Container, null,
                    React__default.createElement(Title, null, t('Scam detection')),
                    React__default.createElement(SliderContainer, null, delay ? (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(SliderItem, { sliderItem: sliderItems[0], buildId: buildId, nextImage: nextImage }),
                        React__default.createElement("div", { style: { width: '100%', height: '52px' } }))) : (React__default.createElement(Slider, { id: 'slider-cheating', transitionTime: 1000, pagination: {
                            maxShow: 6
                        }, autoEnable: true }, sliderItems.map(function (sliderItem, index) {
                        return (React__default.createElement(SliderItem, { key: index, sliderItem: sliderItem, buildId: buildId, nextImage: nextImage }));
                    })))),
                    React__default.createElement(Button, { id: 'reportBtn', type: 'primary', ref: buttonRef, onClick: handleClickReport, disabled: isReportedJob, outline: 'outline', style: { width: '100%' } }, isReportedJob ? t('Reported this job') : t('Report job')))))));
};

export { SliderItem, ReportJobModal as default };
//# sourceMappingURL=index.js.map
